const WishlistSvg = ({ height = 16, width = 16 , val = null }) => {
    return (
        <svg
            viewBox="0 0 17 17"
            className="sc-beqWaB ixusxy hear-icon-mobile"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                width: "20px",
                height: "20px",
                fill: val?.isfav ? "red" : "transparent",
                stroke: "black",
                strokeWidth: val?.isfav ? "0" : 1,
                cursor: "pointer",
                flexShrink: 0,
            }}
        >
            <path
                fillRule="evenodd"
                d="M8.5,2.3C12.9-2.2,24,5.7,8.5,16C-7,5.7,4.1-2.2,8.5,2.3z"
            ></path>
        </svg>
    )
}

export default WishlistSvg;